import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue";
const _hoisted_1 = ["href"];
const _hoisted_2 = { class: "rounded bg-white p-3" };
const _hoisted_3 = { class: "mb-3" };
const _hoisted_4 = ["href"];
const _hoisted_5 = { class: "form-floating mb-3" };
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["id"];
const _hoisted_10 = ["id", "onClick"];
const _hoisted_11 = ["id", "onUpdate:modelValue", "min", "max"];
const _hoisted_12 = ["id"];
const _hoisted_13 = ["id", "onClick"];
const _hoisted_14 = ["id", "onClick"];
const _hoisted_15 = ["id"];
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
import { standardFunctions } from '@/Configurator/Composables/standardFunctions';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        configurationUuid: String,
        configurationObjectType: String,
        dimensionSheet: Object,
        dimensionSheetObjects: Object,
        printConfigImageSrc: {
            type: String,
            default: null
        },
        objectHeight: {
            type: Number,
            default: 0
        },
        objectWidth: {
            type: Number,
            default: 0
        },
        printWidth: {
            type: Number,
            default: 0
        },
        printHeight: {
            type: Number,
            default: 0
        },
        bottomDistance: {
            type: Number,
            default: 0
        },
        printImageSrc: {
            type: String,
            default: null
        },
        coloring: {
            type: String,
            default: null
        }
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { mmToPx } = standardFunctions();
        const props = __props;
        const confirm = useConfirm();
        const scaleFactor = ref(3.7);
        const rightDistanceAdd = ref(50);
        const currentChangeObject = ref(null);
        const updateDimensionSheetForm = useForm({
            articleCode: props.dimensionSheet ? props.dimensionSheet.articleCode : null,
        });
        onMounted(() => {
            if (props.configurationObjectType == 'lid') {
                scaleFactor.value = 0.8;
            }
        });
        function updateDimensionSheet() {
            if (props.dimensionSheet == null) {
                return;
            }
            updateDimensionSheetForm.transform((data) => ({
                article_code: data.articleCode
            })).submit('put', route('admin.dimensionSheets.update', props.dimensionSheet.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function createObjectDistance() {
            if (props.dimensionSheet == null) {
                return;
            }
            router.post(route('admin.dimensionSheets.objects.store', props.dimensionSheet.uuid), {}, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function changeObjectDistance(object) {
            router.put(route('admin.dimensionSheets.objects.updateDistance', object.uuid), {
                distance_mm: object.bottomDistanceMm - props.bottomDistance
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeObject(object) {
            confirm.require({
                message: 'Soll die Hilfslinie wirklich gelöscht werden?',
                header: 'Hilfslinie löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.dimensionSheets.objects.destroy', object.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function removeAllObjects() {
            confirm.require({
                message: 'Sollen wirklich alle Hilfslinien gelöscht werden? Alle Hilfslinien werden somit auf Basis der Konfiguration neu generiert.',
                header: 'Alle Hilfslinien löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (props.dimensionSheet == null) {
                        return;
                    }
                    router.delete(route('admin.dimensionSheets.objects.destroyAll', props.dimensionSheet.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Maßblatterstellung" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "fw-bold mb-3" }, "Maßblatterstellung", -1)),
                        _createElementVNode("a", {
                            href: _ctx.route('admin.configurations.edit', props.configurationUuid),
                            class: "btn btn-primary text-white mb-3"
                        }, "zur Konfiguration", 8, _hoisted_1),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                (props.dimensionSheet)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: _ctx.route('admin.dimensionSheets.download', props.dimensionSheet.uuid) + '?generated=1',
                                        class: "btn btn-primary text-white d-inline-flex align-items-center me-3"
                                    }, [...(_cache[3] || (_cache[3] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-file-earmark-pdf",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" }),
                                                _createElementVNode("path", { d: "M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" })
                                            ], -1),
                                            _createElementVNode("span", { class: "ms-2" }, "Download", -1)
                                        ]))], 8, _hoisted_4))
                                    : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                    class: "btn btn-secondary d-inline-flex align-items-center me-3",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (createObjectDistance()))
                                }, [...(_cache[4] || (_cache[4] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-plus-lg",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", {
                                                "fill-rule": "evenodd",
                                                d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                            })
                                        ], -1),
                                        _createElementVNode("span", { class: "ms-2" }, "Neue Hilfslinie", -1)
                                    ]))]),
                                _createElementVNode("button", {
                                    class: "btn btn-warning d-inline-flex align-items-center",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (removeAllObjects()))
                                }, [...(_cache[5] || (_cache[5] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-arrow-repeat",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9" }),
                                            _createElementVNode("path", {
                                                "fill-rule": "evenodd",
                                                d: "M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"
                                            })
                                        ], -1),
                                        _createElementVNode("span", { class: "ms-2" }, "Distanz-Angaben zurücksetzen", -1)
                                    ]))])
                            ]),
                            _createElementVNode("form", {
                                onSubmit: _withModifiers(updateDimensionSheet, ["prevent"])
                            }, [
                                _createElementVNode("div", _hoisted_5, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "articleCode",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(updateDimensionSheetForm).articleCode) = $event))
                                    }, null, 512), [
                                        [_vModelText, _unref(updateDimensionSheetForm).articleCode]
                                    ]),
                                    _cache[6] || (_cache[6] = _createElementVNode("label", { for: "articleCode" }, "Artikelnummer - article code", -1))
                                ]),
                                _cache[7] || (_cache[7] = _createElementVNode("button", {
                                    type: "submit",
                                    class: "btn btn-success d-inline-flex align-items-center mb-4"
                                }, [
                                    _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "currentColor",
                                        class: "bi bi-check2",
                                        viewBox: "0 0 16 16"
                                    }, [
                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                    ]),
                                    _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                ], -1))
                            ], 32),
                            _createElementVNode("div", {
                                id: "maincontent",
                                class: "position-relative w-100 mb-5 ml-2",
                                style: _normalizeStyle([{ "border-bottom": "solid 1px #000000" }, {
                                        height: ((_unref(mmToPx)(props.objectHeight) / scaleFactor.value) + 50) + 'px'
                                    }])
                            }, [
                                (props.configurationObjectType == 'lid')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        id: "lid-bg",
                                        class: "position-absolute",
                                        style: _normalizeStyle([{ "z-index": "999", "bottom": "0px", "left": "50%", "transform": "translate(-50%)", "background-size": "cover" }, {
                                                width: ((_unref(mmToPx)(props.objectWidth) / scaleFactor.value)) + 'px',
                                                height: ((_unref(mmToPx)(props.objectHeight) / scaleFactor.value)) + 'px'
                                            }])
                                    }, [
                                        _createElementVNode("img", {
                                            src: props.printConfigImageSrc,
                                            style: { "position": "absolute", "width": "100%", "height": "100%" }
                                        }, null, 8, _hoisted_6),
                                        (props.coloring)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                style: _normalizeStyle([{ "width": "100%", "height": "100%", "border-radius": "500px", "opacity": "0.5" }, {
                                                        backgroundColor: props.coloring
                                                    }])
                                            }, null, 4))
                                            : _createCommentVNode("", true)
                                    ], 4))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                    id: "print-area",
                                    class: "position-absolute",
                                    style: _normalizeStyle([{ "border": "dashed 1px rgba(255, 0, 0, 1)", "z-index": "999" }, {
                                            width: ((_unref(mmToPx)(props.printWidth) / scaleFactor.value)) + 'px',
                                            height: ((_unref(mmToPx)(props.printHeight) / scaleFactor.value)) + 'px',
                                            bottom: ((_unref(mmToPx)(props.bottomDistance) / scaleFactor.value)) + 'px',
                                            left: props.configurationObjectType == 'lid' ? '50%' : '0%',
                                            transform: props.configurationObjectType == 'lid' ? 'translate(-50%)' : 'translate(0%)',
                                        }])
                                }, null, 4),
                                _createElementVNode("div", {
                                    id: "print-image",
                                    class: "position-absolute",
                                    style: _normalizeStyle([{
                                            width: ((_unref(mmToPx)(props.printWidth) / scaleFactor.value)) + 'px',
                                            height: ((_unref(mmToPx)(props.printHeight) / scaleFactor.value)) + 'px',
                                            bottom: ((_unref(mmToPx)(props.bottomDistance) / scaleFactor.value)) + 'px',
                                            backgroundImage: 'url(' + props.printImageSrc + ')',
                                            left: props.configurationObjectType == 'lid' ? '50%' : '0%',
                                            transform: props.configurationObjectType == 'lid' ? 'translate(-50%)' : 'translate(0%)',
                                        }, { "z-index": "1000", "background-size": "100% 100%" }])
                                }, null, 4),
                                (props.configurationObjectType == 'bottle')
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        id: "front-bottle",
                                        class: "position-absolute bottom-0",
                                        src: props.printConfigImageSrc,
                                        style: _normalizeStyle({
                                            width: ((_unref(mmToPx)(props.objectWidth) / scaleFactor.value)) + 'px',
                                            height: ((_unref(mmToPx)(props.objectHeight) / scaleFactor.value)) + 'px',
                                            left: ((_unref(mmToPx)(props.printWidth) / scaleFactor.value / 4) - (_unref(mmToPx)(props.objectWidth) / scaleFactor.value / 2)) + 'px'
                                        })
                                    }, null, 12, _hoisted_7))
                                    : _createCommentVNode("", true),
                                (props.configurationObjectType == 'bottle')
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 2,
                                        id: "back-bottle",
                                        class: "position-absolute bottom-0",
                                        src: props.printConfigImageSrc,
                                        style: _normalizeStyle({
                                            width: ((_unref(mmToPx)(props.objectWidth) / scaleFactor.value)) + 'px',
                                            height: ((_unref(mmToPx)(props.objectHeight) / scaleFactor.value)) + 'px',
                                            left: ((_unref(mmToPx)(props.printWidth) / scaleFactor.value / 4 * 3) - (_unref(mmToPx)(props.objectWidth) / scaleFactor.value / 2)) + 'px'
                                        })
                                    }, null, 12, _hoisted_8))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dimensionSheetObjects, (object, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: "distance-line",
                                        id: 'distance-' + object.uuid + '-line',
                                        style: _normalizeStyle({
                                            bottom: ((_unref(mmToPx)(object.bottomDistanceMm) / scaleFactor.value)) + 'px',
                                            right: ((parseInt(index) + 1) * rightDistanceAdd.value) + 'px'
                                        })
                                    }, null, 12, _hoisted_9));
                                }), 256)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dimensionSheetObjects, (object, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: "distance-info",
                                        id: 'distance-' + object.uuid + '-info',
                                        style: _normalizeStyle({
                                            bottom: ((_unref(mmToPx)(object.bottomDistanceMm) / scaleFactor.value)) + 'px',
                                            right: ((parseInt(index) + 1) * rightDistanceAdd.value) + 'px'
                                        }),
                                        onClick: ($event) => (currentChangeObject.value = object.uuid)
                                    }, [
                                        (currentChangeObject.value == object.uuid)
                                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                key: 0,
                                                type: "number",
                                                class: "me-2",
                                                id: 'distance-' + object.uuid,
                                                "onUpdate:modelValue": ($event) => ((object.bottomDistanceMm) = $event),
                                                step: "0.1",
                                                min: props.bottomDistance,
                                                max: (props.printHeight + props.bottomDistance)
                                            }, null, 8, _hoisted_11)), [
                                                [_vModelText, object.bottomDistanceMm]
                                            ])
                                            : _createCommentVNode("", true),
                                        _createElementVNode("span", {
                                            id: 'distance-' + object.uuid + '-mm'
                                        }, _toDisplayString(object.bottomDistanceMm.toFixed(1)) + " mm", 9, _hoisted_12),
                                        (currentChangeObject.value == object.uuid)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                type: "button",
                                                id: 'distance-' + object.uuid + '-change',
                                                class: "btn btn-success btn-sm ms-2",
                                                onClick: ($event) => (changeObjectDistance(object))
                                            }, "Speichern", 8, _hoisted_13))
                                            : _createCommentVNode("", true),
                                        (currentChangeObject.value == object.uuid)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                type: "button",
                                                id: 'distance-' + object.uuid + '-remove',
                                                class: "btn btn-danger btn-sm float-right ms-2 mb-1",
                                                onClick: ($event) => (removeObject(object))
                                            }, [...(_cache[8] || (_cache[8] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "12",
                                                        fill: "currentColor",
                                                        class: "bi bi-trash",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" }),
                                                        _createElementVNode("path", { d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" })
                                                    ], -1)
                                                ]))], 8, _hoisted_14))
                                            : _createCommentVNode("", true)
                                    ], 12, _hoisted_10));
                                }), 256)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dimensionSheetObjects, (object, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: "distance-vertical-line",
                                        id: 'distance-' + object.uuid + '-vertical-line',
                                        style: _normalizeStyle({
                                            height: ((_unref(mmToPx)(object.bottomDistanceMm) / scaleFactor.value)) + 'px',
                                            right: ((parseInt(index) + 1) * rightDistanceAdd.value) + 'px'
                                        })
                                    }, null, 12, _hoisted_15));
                                }), 256))
                            ], 4)
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
